export const OFFICIAL_SITE = "https://www.nexora-global.io/";

export const NX_CONTRACT = "0xF44c599943EB34f6502B7Ba929BaAc15E7AFEe68";
export const NX_SCAN = "https://bscscan.com/address/0xF44c599943EB34f6502B7Ba929BaAc15E7AFEe68";
export const AFG_CONTRACT = "0x3a9E57Becb91115cC51e4851b1E0ea04dC57EE7e";
export const AFG_SCAN = "https://bscscan.com/address/0x3a9E57Becb91115cC51e4851b1E0ea04dC57EE7e";

export const NAV_LINKS = [
    { label: "Ecosystem", href: "#ecosystem" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "Matrix", href: "#matrix" },
    { label: "AFG Token", href: "#afg-token" },
    { label: "Roadmap", href: "#roadmap" },
];

export const AFFILIATE_LEVELS = [
    { level: "L1", pct: 40 },
    { level: "L2", pct: 15 },
    { level: "L3", pct: 15 },
    { level: "L4", pct: 10 },
    { level: "L5", pct: 10 },
    { level: "L6", pct: 5 },
    { level: "L7", pct: 5 },
];

export const MATRIX_LEVELS = [
    { level: 1, price: 5, salary: 0.5, affiliate: 2.5, matrix: 2 },
    { level: 2, price: 10, salary: 1, affiliate: 5, matrix: 4 },
    { level: 3, price: 15, salary: 1.5, affiliate: 7.5, matrix: 6 },
    { level: 4, price: 25, salary: 2.5, affiliate: 12.5, matrix: 10 },
    { level: 5, price: 40, salary: 4, affiliate: 20, matrix: 16 },
    { level: 6, price: 75, salary: 7.5, affiliate: 37.5, matrix: 30 },
    { level: 7, price: 130, salary: 13, affiliate: 65, matrix: 52 },
    { level: 8, price: 250, salary: 25, affiliate: 125, matrix: 100 },
    { level: 9, price: 450, salary: 45, affiliate: 225, matrix: 180 },
    { level: 10, price: 800, salary: 80, affiliate: 400, matrix: 320 },
    { level: 11, price: 1200, salary: 120, affiliate: 600, matrix: 480 },
    { level: 12, price: 2000, salary: 200, affiliate: 1000, matrix: 800 },
];

export const LEVEL_REWARDS = [2, 4, 8, 10, 15, 25, 50, 75, 100, 150, 200, 500, 1000];

export const SALARY_FUND = [
    {
        pct: 35,
        title: "Top 50 Leaders",
        desc: "The Top 50 leaders share 35% of the Monthly Salary Fund. Ranking is based on team performance and income generation.",
    },
    {
        pct: 20,
        title: "Level 2\u20136",
        desc: "Requires active Levels 2 to 6, a minimum of 50 active teams and 20+ new members joining every month.",
    },
    {
        pct: 45,
        title: "Level 7\u201312",
        desc: "Requires active Levels 7 to 12. Every qualifying member shares 45% of the Monthly Salary Fund \u2014 higher levels, higher rewards.",
    },
];

export const COMMUNITY_REWARDS = [
    { partners: "50 Partners", team: "250 Team", bonus: "$50" },
    { partners: "250 Partners", team: "1,000 Team", bonus: "$300" },
    { partners: "1,000 Partners", team: "10,000 Team", bonus: "$2,000" },
];

export const WALLETS = [
    "Trust Wallet",
    "TokenPocket",
    "MetaMask",
    "Binance Wallet",
    "SafePal",
    "More Wallets",
];

export const ROADMAP = [
    "Nexora Global",
    "Token Trade",
    "Gold Global Program",
    "AFG Token",
    "AFG DEX Listing",
    "Nexora Wallet",
];

export const SOCIALS = [
    { key: "telegram-group", label: "Telegram Group", handle: "t.me/NexoraGlobalOfficialGroup", href: "https://t.me/NexoraGlobalOfficialGroup" },
    { key: "telegram-channel", label: "Telegram Channel", handle: "t.me/nexoraofficials", href: "https://t.me/nexoraofficials" },
    { key: "tiktok", label: "TikTok", handle: "@nexora.world.global", href: "https://tiktok.com/@nexora.world.global" },
    { key: "youtube", label: "YouTube", handle: "@NexoraWorldsGlobal", href: "https://www.youtube.com/@NexoraWorldsGlobal" },
    { key: "website", label: "Website", handle: "www.nexora-global.io", href: "https://www.nexora-global.io/" },
];

export const formatUsd = (n) =>
    `$${n.toLocaleString("en-US", { minimumFractionDigits: n % 1 !== 0 ? 2 : 0, maximumFractionDigits: 2 })}`;
